import { Component, inject, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { getBrowserCultureLang, TranslocoPipe, TranslocoService } from "@jsverse/transloco";

import { LocalStorageService } from "@services/local-storage.service";
import { DxButtonModule } from "devextreme-angular/ui/button";

@Component({
    selector: "app-login-failed",
    imports: [RouterLink, DxButtonModule, TranslocoPipe],
    templateUrl: "./login-failed.component.html",
    styleUrls: ["./login-failed.component.css"]
})
export class LoginFailedComponent implements OnInit {
    language: string;
    private localStorageService = inject(LocalStorageService);
    private translocoService = inject(TranslocoService);

    ngOnInit(): void {
        this.translocoService.setAvailableLangs(["pt-BR", "en-US", "es-ES"]);
        const browserLang = getBrowserCultureLang();
        this.language = this.localStorageService.get("lang")
            ? browserLang.match(/pt-BR|es-ES|en-US/)
                ? browserLang
                : "en-US"
            : browserLang;

        this.translocoService.setActiveLang(this.language);
    }
}
